export const camelCaseToSpaced = (text: string, roleIncluded: boolean = false): string => {
  if (roleIncluded) {
    if (text === text.toUpperCase()) {
      return text;
    }

    const matchResult = text.match(/^([A-Z]+?)(?=[A-Z][a-z])(.*)$/);
    if (matchResult) {
      const [, acronym, rest] = matchResult;
      // space out the remainder on each uppercase boundary
      const spacedRest = rest
        .replace(/([A-Z])/g, ' $1')
        .trim();
      return acronym + (spacedRest ? ' ' + spacedRest : '');
    }
  }

  return text
    .replace(/([A-Z])/g, ' $1')
    .trim();
};


export const removeHyphens = (text: string) => {
  return text.replace(/-/g, ' ');
}

export const roundToTwoDecimals = (value: number) => {
  return Math.round(value * 100) / 100;
}


export const formatJobRole = (role: string) => {
  if (role.length === 3) {
    return role.toUpperCase();
  } else {
    return removeHyphens(role)
      .split(' ')
      .map(word =>
        word.charAt(0).toUpperCase() +
        word.slice(1).toLowerCase()
      )
      .join(' ');
  }
}